import React, { ReactElement } from 'react';
import { Route, HashRouter as Router } from 'react-router-dom';
import Home from './pages/home';
import Record from './pages/record'
import Privilege from './pages/privilege'
import Rules from './pages/rules'
import Agreement from './pages/agreement'

const App = (): ReactElement => {
  return (
    <Router>
      <Route path="/" exact component={Home} />
      <Route path="/record" exact component={Record} />
      <Route path="/privilege" exact component={Privilege} />
      <Route path="/rules" exact component={Rules} />
      <Route path="/agreement" exact component={Agreement} />
    </Router>
  );
};

export default App;
